var Zoom = (function() {
    'use strict';
    var utils = require('./utils');

    function init() {

        var savedFontSize = localStorage.getItem("murli.fontSize");
        var currentFontSize = parseInt($("#murli-container").css("font-size"));
        if (!utils.isBlank(savedFontSize) && currentFontSize != savedFontSize) {
            $('#murli-container').animate({'font-size':savedFontSize + "px"}, 100);
        }

        $("#zoom-in , #m-zoom-in").click(function(event) {
            event.preventDefault();
            var fontSize = parseInt($("#murli-container").css("font-size"));
            fontSize = fontSize + 1;
            $('#murli-container').animate({'font-size':fontSize + "px"}, 100);
            localStorage.setItem("murli.fontSize", fontSize);
        });

        $("#zoom-out, #m-zoom-out").click(function(event) {
            event.preventDefault();
            var fontSize = parseInt($("#murli-container").css("font-size"));
            fontSize = fontSize - 1;
            $('#murli-container').animate({'font-size':fontSize + "px"}, 100);
            localStorage.setItem("murli.fontSize", fontSize);
        });

        $("#full-screen").click(function() {
            /*if ($(this).scrollTop()!==0){
                $("header").fadeOut();
                $("#button-bar").fadeOut();
            }*/
            if($("#full-screen i").hasClass( "icon-expand" )){
                $("#full-screen i").addClass("icon-compress").removeClass("icon-expand");
                //$("header").hide();
            }else{
                $("#full-screen i").addClass("icon-expand").removeClass("icon-compress");
                //$("header").show();
            }
            $('#murli-container').toggleClass("container").toggleClass("containter-fluid pa-1 px-2");
            $("#nav-container").toggleClass("container").toggleClass("containter-fluid px-2");
            $("#header-container").toggleClass("container").toggleClass("containter-fluid px-2");
            $("#footer-text").toggleClass("container").toggleClass("containter-fluid px-2");
            $("#footer-zoom").toggleClass("container").toggleClass("containter-fluid px-2");
        });
    }

    return {
        init: init
    };
}());

module.exports = Zoom;
